__turbopack_context__.v({
  "container": "Checkbox-module__gTZQKa__container",
  "container__checkbox": "Checkbox-module__gTZQKa__container__checkbox",
  "container__error_message": "Checkbox-module__gTZQKa__container__error_message",
  "container__label": "Checkbox-module__gTZQKa__container__label",
});
